import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { getOrderInProgress, makeGetOrder  } from '../../selectors/order'
import { makeGetCurrentMenu } from '../../selectors/menus'
import { clearCart } from '../../actions/cart'
import { printOrder } from '../../actions/printer'
import QRCodeReceipt from '../../components/receipt/QRCodeReceipt'
import { getTax } from '../../selectors/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import { sendOrderEmail } from '../../actions/order'
import { USE_RICH_CHECKOUT } from '../../constants'
import { centsToDollars } from '../../utils/formatters'

const mapStateToProps = (state, ownProps) => {
  const orderUuid = get(ownProps, 'match.params.orderUuid', undefined)
  const paymentId = ownProps?.match?.params?.paymentId
  let hasBalanceDueInCents = false
  let order = {}
  let balanceDueDisplay
  if (orderUuid === 'split-tender') {
    order = getOrderInProgress (state)
  } else {
    const getOrder = makeGetOrder()
    order = orderUuid ? getOrder(state, orderUuid) : getOrder(state, state.order.currentOrderId)
  }

  if (paymentId) {
    hasBalanceDueInCents = order?.balanceDueInCents !== 0
    balanceDueDisplay = centsToDollars(order?.balanceDueInCents ?? 0)
  }

  const isNewOrder = !order?.submittedAt
  const isRichCheckout = USE_RICH_CHECKOUT === 'true'
  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const taxRate = getTax(state)

  // FIXME: This shouldn't be hardcoded, also the URL throws an error
  const qrCodeData = `https://gators.ordernext.com/orders/${orderUuid}`

  const available = state?.config?.networkAvailable ?? false
  return {
    menu,
    order,
    taxRate,
    qrCodeData,
    isRichCheckout,
    paymentId,
    hasBalanceDueInCents,
    balanceDueDisplay,
    isNewOrder,
    available
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const push = ownProps?.history?.push ?? (() => {})

  return {
    onDone: (hasBalanceDueInCents) => {
        if (hasBalanceDueInCents) {
          push('/split-tender')
        } else {
        dispatch(clearCart())
        dispatch(clearPromotionsOnOrder())
        push('/concession-order')
      }
    },
    sendEmails: (orderUuid, emails, paymentUuid) => dispatch(sendOrderEmail({ orderUuid, emails, paymentUuid })),
    printOrder: (params) => dispatch(printOrder(params)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QRCodeReceipt))
